import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanLoadPerfil } from './shared/canLoadPerfil/canLoadPerfil.guard';

const routes: Routes = [
  { path: '', loadChildren: './publico/publico.module' },
  { path: 'coordinados', loadChildren: './coordinados/coordinados.module' },
  { path: 'coordinador', loadChildren: './coordinador/coordinador.module' },
  { path: 'admin', loadChildren: './admin/admin.module', canLoad: [CanLoadPerfil]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, enableTracing: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
